import {
  ADD_DEPARTMENT,
  GET_DEPARTMENTS,
  GET_DEPARTMENT_BY_ID,
  EDIT_DEPARTMENT,
  REMOVE_DEPARTMENT,
} from "../actions/department-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const departmentReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (ADD_DEPARTMENT.REQUEST,
    GET_DEPARTMENTS.REQUEST,
    GET_DEPARTMENT_BY_ID.REQUEST,
    EDIT_DEPARTMENT.REQUEST,
    REMOVE_DEPARTMENT.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_DEPARTMENT.SUCCESS,
    GET_DEPARTMENTS.SUCCESS,
    GET_DEPARTMENT_BY_ID.SUCCESS,
    EDIT_DEPARTMENT.SUCCESS,
    REMOVE_DEPARTMENT.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_DEPARTMENT.FAILURE,
    GET_DEPARTMENTS.FAILURE,
    GET_DEPARTMENT_BY_ID.FAILURE,
    EDIT_DEPARTMENT.FAILURE,
    REMOVE_DEPARTMENT.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { departmentReducer };
